var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"color":"#5087e6","length":_vm.setting.total_page,"total-visible":_vm.setting.total_visible},on:{"input":_vm.chagePerPage},model:{value:(_vm.page_idx),callback:function ($$v) {_vm.page_idx=$$v},expression:"page_idx"}})
}
var staticRenderFns = []

export { render, staticRenderFns }